<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-center">
    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div id="form-fields" class="md:p-8 mb-6">
          <div
            class="bg-white rounded shadow-lg p-4 px-4 md:-mt-6 grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3"
          >
            <div class="text-left block">
              <p class="mb-2 font-medium text-lg text-gray-800">
                {{ descriptionTitle }}
              </p>
            </div>

            <div class="lg:col-span-2">
              <div
                class="p-6 space-y-4 max-w-4xl mx-auto bg-white rounded shadow"
              >
                <!-- CARROSSEL -->
                <section>
                  <div class="block text-start border-b pb-2 mb-4">
                    <h2 class="text-xl font-semibold text-start">
                      🎞️ Carrossel de Destaque
                    </h2>
                    <small class="text-left font-normal text-gray-500">
                      Adicione imagens em destaque para sua página inicial
                    </small>
                  </div>

                  <div class="flex flex-wrap gap-4 mb-4">
                    <div
                      v-for="(slide, index) in store.state.data.carousel"
                      :key="index"
                      class="flex flex-col md:flex-row md:items-center gap-4 mb-4 w-full"
                    >
                      <!-- {{ slide }} -->
                      <!-- preview ou imagem do back -->
                      <div class="w-full h-24 mb-2 bg-gray-100 rounded overflow-hidden">
                        <img
                          v-if="slide"
                          :src="fileUrl + slide"
                          alt="Slide preview"
                          class="w-full h-full object-cover"
                        />
                      </div>
                      
                      <input
                        type="file"
                        @change="updateImage($event, index)"
                        class="block w-full md:w-auto"
                      />
                      
                      <button
                        @click="removeSlide(index)"
                        class="text-red-600 hover:underline"
                      >
                        Remover
                      </button>
                    </div>
                  </div>

                  <button
                    @click="addSlide"
                    class="text-blue-600 hover:underline"
                  >
                    + Adicionar Slide
                  </button>
                </section>

                <!-- DESCRIÇÃO INICIAL -->
                <div class="md:col-span-5">
                  <div class="block text-start">
                    <h2 class="text-xl font-semibold text-start">
                      Descrição inicial <a class="text-red-600 ml-1">*</a>
                    </h2>
                    <small class="text-left font-normal text-gray-500">
                      Defina o texto em destaque da sua página inicial
                    </small>
                  </div>

                  <div
                    class="mx-1 my-2"
                  >
                    <textarea
                      name="desc"
                      v-model="store.state.data.mainDesc"
                      class="input-field"
                    >
                    </textarea>
                  </div>

                  <span
                    name="highlights.first.desc"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- CARD PRINCIPAL -->
                <div class="md:col-span-2">
                  <div class="block text-start">
                    <h2 class="text-xl font-semibold text-start">
                      Evento principal
                    </h2>
                    <small class="text-left font-normal text-gray-500">
                      Defina um evento para ficar em destaque no app 
                    </small>
                  </div>

                  <div
                    class="h-10 flex rounded items-center mt-1.5 w-full"
                  >
                  <SimpleSelect
                    class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                    :data="events"
                    :initial-value="dataStock.state.data.mainEvent"
                    @selected-data="(val) => (dataStock.state.data.mainEvent = val)"
                  />
                  </div>
                </div>

                <!-- DOWNLOAD DO APP -->
                <div class="md:col-span-2">
                  <div class="block text-start">
                    <h2 class="text-xl font-semibold text-start">
                      Download do app
                    </h2>
                    <small class="text-left font-normal text-gray-500">
                      
                    </small>
                  </div>

                  <div
                    class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                  >
                    <!-- titulo -->
                    <div class="md:col-span-5">
                      <BaseInput
                        type="text"
                        name="title"
                        v-model="store.state.data.downloadApp.desc"
                        label="Descrição para download"
                        :info="'Descrição'"
                        :required-field="true"
                        :activeDefault="false"
                      >
                        <template #append>
                          <CleanInputButton @click="store.state.data.downloadApp.desc = null" />
                        </template>
                      </BaseInput>

                      <span
                        name="downloadApp.desc"
                        class="text-red-600 text-sm"
                      />
                    </div>

                    <div class="md:col-span-5">
                      <div class="md:col-span-5 md:-mt-1 flex h-10">
                        <label
                          class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                        >
                          <div class="flex mt-auto mb-auto h-full">
                            <div class="w-full mt-auto mb-auto flex justify-center">
                              <component
                                :is="PhFileImage"
                                class="w-5 h-5 mr-1 text-green-500"
                              />

                              Banner
                            </div>
                          </div>
                          <input
                            type="file"
                            class="hidden"
                            @change="(e) => handleFileChange(e, 'download')"
                          />
                        </label>
                        <input
                          type="text"
                          style="padding-left: 10px !important"
                          class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                          :value="store.state.data.downloadApp.image"
                        />
                      </div>
                    </div>

                  </div>
                </div>

                <!-- DESTAQUES -->
                <section>
                  <h2 class="text-xl font-semibold text-start">
                    Destaques da página inicial
                  </h2>
                </section>

                <!-- 1º -->
                <div
                  @click="toggleTab('first')"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      1º DESTAQUE
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': firstHighlight }"
                    ></component>
                  </div>
                </div>
                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="firstHighlight"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- titulo -->
                      <div class="md:col-span-5">
                        <BaseInput
                          type="text"
                          name="title"
                          v-model="store.state.data.highlights.first.title"
                          label="Titulo"
                          :info="'Titulo deste destaque'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.data.highlights.first.title = null" />
                          </template>
                        </BaseInput>

                        <span
                          name="highlights.first.title"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- desc -->
                      <div class="md:col-span-5">
                        <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                          Descrição <a class="text-red-600 ml-1">*</a>
                        </label>
                        <div
                          class="mx-1 my-2"
                        >
                          <textarea
                            name="desc"
                            v-model="store.state.data.highlights.first.desc"
                            class="input-field"
                          >
                          </textarea>
                        </div>

                        <span
                          name="highlights.first.desc"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- image -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-5 md:-mt-1 flex h-10">
                          <label
                            class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                          >
                            <div class="flex mt-auto mb-auto h-full">
                              <div class="w-full mt-auto mb-auto flex justify-center">
                                <component
                                  :is="PhFileImage"
                                  class="w-5 h-5 mr-1 text-green-500"
                                />

                                Banner
                              </div>
                            </div>
                            <input
                              type="file"
                              class="hidden"
                              @change="(e) => handleFileChange(e, 'first')"
                            />
                          </label>
                          <input
                            type="text"
                            style="padding-left: 10px !important"
                            class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                            :value="store.state.data.highlights.first.selectedFileName"
                          />
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>

                <!-- 2º -->
                <div
                  @click="toggleTab('second')"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      2º DESTAQUE
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': secondHighlight }"
                    ></component>
                  </div>
                </div>
                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="secondHighlight"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- titulo -->
                      <div class="md:col-span-5">
                        <BaseInput
                          type="text"
                          name="title"
                          v-model="store.state.data.highlights.second.title"
                          label="Titulo"
                          :info="'Titulo deste destaque'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.data.highlights.second.title = null" />
                          </template>
                        </BaseInput>

                        <span
                          name="highlights.second.title"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- desc -->
                      <div class="md:col-span-5">
                        <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                          Descrição <a class="text-red-600 ml-1">*</a>
                        </label>
                        <div
                          class="mx-1 my-2"
                        >
                          <textarea
                            name="desc"
                            v-model="store.state.data.highlights.second.desc"
                            class="input-field"
                          >
                          </textarea>
                        </div>

                        <span
                          name="highlights.second.desc"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- image -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-5 md:-mt-1 flex h-10">
                          <label
                            class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                          >
                            <div class="flex mt-auto mb-auto h-full">
                              <div class="w-full mt-auto mb-auto flex justify-center">
                                <component
                                  :is="PhFileImage"
                                  class="w-5 h-5 mr-1 text-green-500"
                                />

                                Banner
                              </div>
                            </div>
                            <input
                              type="file"
                              class="hidden"
                              @change="(e) => handleFileChange(e, 'second')"
                            />
                          </label>
                          <input
                            type="text"
                            style="padding-left: 10px !important"
                            class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                            :value="store.state.data.highlights.second.selectedFileName"
                          />
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>

                <!-- 3º -->
                <div
                  @click="toggleTab('third')"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      3º DESTAQUE
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': thirdHighlight }"
                    ></component>
                  </div>
                </div>
                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="thirdHighlight"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- titulo -->
                      <div class="md:col-span-5">
                        <BaseInput
                          type="text"
                          name="title"
                          v-model="store.state.data.highlights.third.title"
                          label="Titulo"
                          :info="'Titulo deste destaque'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.data.highlights.third.title = null" />
                          </template>
                        </BaseInput>

                        <span
                          name="highlights.third.title"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- desc -->
                      <div class="md:col-span-5">
                        <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                          Descrição <a class="text-red-600 ml-1">*</a>
                        </label>
                        <div
                          class="mx-1 my-2"
                        >
                          <textarea
                            name="desc"
                            v-model="store.state.data.highlights.third.desc"
                            class="input-field"
                          >
                          </textarea>
                        </div>

                        <span
                          name="highlights.third.desc"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- image -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-5 md:-mt-1 flex h-10">
                          <label
                            class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                          >
                            <div class="flex mt-auto mb-auto h-full">
                              <div class="w-full mt-auto mb-auto flex justify-center">
                                <component
                                  :is="PhFileImage"
                                  class="w-5 h-5 mr-1 text-green-500"
                                />

                                Banner
                              </div>
                            </div>
                            <input
                              type="file"
                              class="hidden"
                              @change="(e) => handleFileChange(e, 'third')"
                            />
                          </label>
                          <input
                            type="text"
                            style="padding-left: 10px !important"
                            class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                            :value="store.state.data.highlights.third.selectedFileName"
                          />
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>

                <!-- LOGIN -->
                <div class="md:col-span-5">
                  <div class="block text-start">
                    <h2 class="text-xl font-semibold text-start">
                      Imagem do login
                    </h2>
                    <small class="text-left font-normal text-gray-500">
                      Defina a imagem que aparecerá no login do app
                    </small>
                  </div>

                  <div class="md:col-span-5 mt-2 flex h-10">
                    <label
                      class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                    >
                      <div class="flex mt-auto mb-auto h-full">
                        <div class="w-full mt-auto mb-auto flex justify-center">
                          <component
                            :is="PhFileImage"
                            class="w-5 h-5 mr-1 text-green-500"
                          />

                          Banner
                        </div>
                      </div>
                      <input
                        type="file"
                        class="hidden"
                        @change="(e) => handleFileChange(e, 'login')"
                      />
                    </label>
                    <input
                      type="text"
                      style="padding-left: 10px !important"
                      class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                      :value="store.state.data.loginImage"
                    />
                  </div>
                </div>

                <!-- APP -->
                <div class="md:col-span-5">
                  <div class="block text-start">
                    <h2 class="text-xl font-semibold">
                      Logo do app
                    </h2>
                    <small class="text-left font-normal text-gray-500">
                      Defina a logo em destaque do seu app
                    </small>
                  </div>

                  <div class="md:col-span-5 mt-2 flex h-10">
                    <label
                      class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                    >
                      <div class="flex mt-auto mb-auto h-full">
                        <div class="w-full mt-auto mb-auto flex justify-center">
                          <component 
                            :is="PhFileImage" 
                            class="w-5 h-5 mr-1 text-green-500"
                          />
                          Banner
                        </div>
                      </div>
                    
                      <input
                        type="file"
                        class="hidden"
                        @change="(e) => handleFileChange(e, 'logo')"
                      />
                    
                    </label>

                    <input
                      type="text"
                      style="padding-left: 10px !important"
                      class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                      :value="store.state.data.logoApp"
                    />
                  </div>
                </div>

                <!-- SALVAR -->
                <div class="text-right flex justify-center md:justify-end">
                  <slot />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import { dataStock } from '../store'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import { PhCaretUp, PhFileImage } from '@phosphor-icons/vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import CleanInputButton from '../components/CleanInputButton.vue'
import stockService from '../services/stock.service'
import { showToast as toast } from '@/helpers/UseToasts'

defineProps({
  descriptionTitle: {
    required: true,
    String
  }
})

const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const firstHighlight = ref(false)
const secondHighlight = ref(false)
const thirdHighlight = ref(false)

const events = computed(() => dataStock.getters.getEventsCollect)
const store = dataStock

function toggleTab (val) {
  switch (val) {
    case 'first':
      firstHighlight.value = !firstHighlight.value
      secondHighlight.value = false
      thirdHighlight.value = false
      break

    case 'second':
      secondHighlight.value = !secondHighlight.value
      firstHighlight.value = false
      thirdHighlight.value = false
      break

    case 'third':
      thirdHighlight.value = !thirdHighlight.value
      secondHighlight.value = false
      firstHighlight.value = false
      break
  }
}

async function handleFileChange (event, state) {
  const file = event.target.files[0]
  if (file) {
    const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (allowedExtensions.includes(fileExtension)) {
      dataStock.dispatch('setUploadFile', true)
      if (state == 'first') {
        store.state.data.highlights.first.selectedFileName = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.highlights.first.image = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload do destaque 1 falhou', 'error')
        }
      }
      if (state == 'second') {
        store.state.data.highlights.second.selectedFileName = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.highlights.second.image = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload do destaque 2 falhou', 'error')
        }
      }
      if (state == 'third') {
        store.state.data.highlights.third.selectedFileName = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.highlights.third.image = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload do destaque 3 falhou', 'error')
        }
      }
      if (state == 'login') {
        store.state.data.loginImage = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.loginImage = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload da imagem do login falhou', 'error')
        }
      }
      if (state == 'logo') {
        store.state.data.logoApp = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.logoApp = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload da logo falhou', 'error')
        }
      }
      if (state == 'download') {
        store.state.data.downloadApp.image = file.name

        try {
          const res = await stockService.saveImage(file)

          store.state.data.downloadApp.image = res.data
          dataStock.dispatch('setUploadFile', false)
        } catch (err) {
          dataStock.dispatch('setUploadFile', false)
          toast('Erro', 'Upload do banner falhou', 'error')
        }
      }
    } else {
      dataStock.dispatch('setUploadFile', false)
      return this.toast(
        'Atenção',
        'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
        'info'
      )
    }
  }
}

// fluxo do carrossel
const updateImage = async (e, index) => {
  dataStock.dispatch('setUploadFile', true)
  const file = e.target.files[0]
  if (!file) return

  const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
  const fileExtension = file.name.split('.').pop().toLowerCase()

  if (!allowedExtensions.includes(fileExtension)) {
    toast('Atenção', 'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas', 'info')
    return
  }

  try {
    const res = await stockService.saveImage(file)

    store.state.data.carousel[index] = res.data
    dataStock.dispatch('setUploadFile', false)
  } catch (err) {
    dataStock.dispatch('setUploadFile', false)
    toast('Erro', 'Upload de imagem falhou', 'error')
  }
}
const addSlide = async () => {
  store.state.data.carousel.push(null)
}
const removeSlide = (index) => {
  store.state.data.carousel.splice(index, 1)
}

</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.input-field {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 10px;
  border: 2px solid #ccc;
  outline: none;
  background-color: transparent;
  transition: border-color 0.3s ease-in-out;
}
</style>
